// extracted by mini-css-extract-plugin
export var numberInputContainer = "_86-0";
export var startPickingButton = "_86-1";